import { createRouter, createWebHistory } from "vue-router";
import LoginView from "@/views/parent/Login.vue";
import LogoutView from "@/views/parent/Logout.vue";
import SsoView from "@/views/parent/Sso.vue";
import MyAgenda from "@/views/parent/MyAgenda.vue";


import MatrixView from "@/views/parent/Matrix.vue";
import PrintView from "@/views/parent/Print.vue";
import Error404View from "@/views/parent/Error404.vue";
import ErrorSSOView from "@/views/parent/ErrorSSO.vue";
import CreateAccount from "@/views/parent/CreateAccount.vue";
import ResetPassword from "@/views/parent/ResetPassword.vue";
import VerifyEmail from "@/views/parent/VerifyEmail.vue";
import ExpiredAccount from "@/views/school/ExpiredAccount.vue";
import SchoolHelp from "@/views/school/Help.vue";

/*
import EventsAndMethods from "@/tutorials/EventsAndMethods.vue";
import FormView from "@/tutorials/Form.vue";
import TabsView from "@/tutorials/tabs.vue";
import CheckboxesView from "@/tutorials/Checkboxes.vue";
*/
import ToggleView from "@/tutorials/toggle.vue";
import Parent from "@/views/parent.vue";

import TeacherLoginView from "@/views/teacher/Login.vue";
import TeacherMeetings from "@/views/teacher/TeacherMeetings.vue";
import TeacherPrintView from "@/views/teacher/Print.vue";
import TeacherResetPassword from "@/views/teacher/ResetPassword.vue";
import Teacher from "@/views/parent.vue";

import SchoolLoginView from "@/views/school/Login.vue";
import AllEventsVue from "@/views/school/AllEvents.vue";
import School from "@/views/parent.vue";
import SchoolEditEventVue from "@/views/school/EditEvent.vue";
import SchoolScheduleVue from "@/views/school/Schedule.vue";

import Support from "@/views/support/Support.vue";
import SupportLoginView from "@/views/support/SupportLogin.vue";
import SupportDirectoryVue from "@/views/support/SupportDirectory.vue";
import SupportDistrictDirectoryVue from "@/views/support/SupportDistrictDirectory.vue";
import SupportLeadsVue from "@/views/support/SupportLeads.vue";

import { useAuthenticationStore } from "./stores/authentication";
import DirectoryVue from "./views/school/Directory.vue";
import IntegrationVue from "./views/school/Integration.vue";
import ReportsVue from "./views/school/Reports.vue";
import SchoolSettingsVue from "./views/school/Settings.vue";
import SchoolUserManagementVue from "./views/school/UserManagement.vue";
import EventWizardVue from "./views/school/EventWizard.vue";
import { useSchoolStore } from "./stores/school";

declare module "vue-router" {
  interface RouteMeta {
    requiresAuth?: boolean;
    title?: string;
    level?: string;
    /** @deprecated Use requiredPolicy — role arrays are kept for backfill transition only */
    requiredRoles?: string[];
    requiredPolicies?: string[];
    /**
     * Policy name the user must hold in JWT `policies[]` to access this route.
     * Takes precedence over requiredRoles when both are present.
     */
    requiredPolicy?: string;
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),

  routes: [
    {
      path: "/VerifyEmail",
      name: "VerifyEmail",
      component: VerifyEmail,
      props: true,
      meta: { requiresAuth: false, title: "Verify Email" }
    },

    {
      path: "/error404",
      name: "error404",
      component: Error404View,
      meta: { requiresAuth: false, title: "Page does not exist" }
    },
    {
      path: "/errorSSO",
      alias: "/errorsso",
      name: "errorSSO",
      component: ErrorSSOView,
      meta: { requiresAuth: false, title: "Authentication error" }
    },
    {
      name: "support-routes",
      path: "/support",
      component: Support,
      children: [
        {
          path: "sso",
          name: "support-sso",
          component: SsoView,
          meta: { requiresAuth: false, title: "Support SSO for PTC Wizard" }
        },
        {
          path: "login",
          name: "support-login",
          component: SupportLoginView,
          meta: { requiresAuth: false, title: "PTC Agent Login" }
        },
        {
          path: "",
          name: "support-accounts",
          component: SupportDirectoryVue,
          meta: {
            requiresAuth: true,
            title: "PTC Agent Support",
            requiredRoles: ["admin"]
          }
        },
        {
          path: "districts",
          name: "support-districts",
          component: SupportDistrictDirectoryVue,
          meta: {
            requiresAuth: true,
            title: "PTC Agent Support",
            requiredRoles: ["admin"]
          }
        },
        {
          path: "leads",
          name: "support-leads",
          component: SupportLeadsVue,
          meta: {
            requiresAuth: true,
            title: "PTC Agent Support - Leads",
            requiredRoles: ["admin"]
          }
        },
        {
          path: "trials",
          redirect: { name: "support-leads", query: { filter: "trials" } },
        }
      ],
      meta: {
        level: "support"
      }
    },
    {
      name: "school-routes",
      path: "/:account/school",
      component: School,
      children: [
        {
          path: "login",
          name: "school-login",
          component: SchoolLoginView,
          meta: { requiresAuth: false, title: "Login to PTC Wizard" }
        },
        {
          path: "logout",
          name: "school-logout",
          component: LogoutView,
          meta: { requiresAuth: false, title: "Logging out" }
        },
        {
          path: "help",
          name: "school-help",
          component: SchoolHelp,
          meta: { requiresAuth: true, title: "Help" }
        },
        {
          name: "school-events",
          path: "",
          component: AllEventsVue,
          meta: {
            requiresAuth: true,
            title: "PTC Wizard - Events",
            requiredPolicy: "school.events.general.read"
          }
        },
        {
          name: "school-edit-events",
          path: "event/:eventId",
          props: true,
          component: SchoolEditEventVue,
          meta: {
            requiresAuth: true,
            title: "PTC Wizard - Edit Event",
            requiredPolicy: "school.events.general.read"
          }
        },
        {
          name: "school-edit-schedule",
          path: "schedule/:eventId",
          props: true,
          component: SchoolScheduleVue,
          meta: {
            requiresAuth: true,
            title: "PTC Wizard - Schedule",
            requiredPolicy: "school.events.schedule.read"
          }
        },
        {
          name: "school-directory",
          path: "directory",
          component: DirectoryVue,
          meta: {
            requiresAuth: true,
            title: "PTC Wizard - Directory",
            requiredPolicy: "school.directory.classes.read"
          }
        },
        {
          name: "school-integration",
          path: "integration",
          component: IntegrationVue,
          meta: {
            requiresAuth: true,
            title: "PTC Wizard - Integration",
            requiredPolicy: "school.integration.read"
          }
        },
        {
          name: "school-reports",
          path: "reports/:eventId",
          props: true,
          component: ReportsVue,
          meta: {
            requiresAuth: true,
            title: "PTC Wizard - Reports",
            requiredPolicy: "school.events.reports.read"
          }
        },
        {
          name: "school-settings",
          path: "settings",
          component: SchoolSettingsVue,
          meta: {
            requiresAuth: true,
            title: "PTC Wizard - Settings",
            requiredPolicy: "school.profile.read"
          }
        },
        {
          name: "school-user-management",
          path: "user-management",
          component: SchoolUserManagementVue,
          meta: {
            requiresAuth: true,
            title: "PTC Wizard - User Management",
            requiredPolicy: "school.users.read"
          }
        },
        {
          name: "school-event-wizard",
          path: "new-event",
          component: EventWizardVue,
          meta: {
            requiresAuth: true,
            title: "PTC Wizard - Event Wizard",
            requiredPolicy: "school.events.general.read"
          }
        },
        {
          name: "expired-account",
          path: "expired-account",
          component: ExpiredAccount,
          meta: { requiresAuth: false, title: "Expired Account" }
        },
        {
          path: ":pathMatch(.*)*",
          component: Error404View,
          meta: { requiresAuth: false, title: "Page does not exist" }
        }
      ],
      meta: {
        level: "school"
      }
    },
    {
      name: "teacher-routes",
      path: "/:account/teacher/",
      component: Teacher,
      children: [
        {
          path: "login",
          name: "teacher-login",
          component: TeacherLoginView,
          props: true,
          meta: { requiresAuth: false, title: "Login to PTC Wizard" }
        },
        {
          path: "",
          name: "Teacher Meetings",
          component: TeacherMeetings,
          meta: { requiresAuth: true, title: "Your PTC Wizard schedule " }
        },
        {
          path: "print",
          name: "teacher-print",
          component: TeacherPrintView,
          props: true,
          meta: { requiresAuth: true, title: "Your PTC Wizard schedule " }
        },
        {
          path: "ResetPassword/:uid",
          name: "teacher-ResetPassword",
          component: TeacherResetPassword,
          props: true,
          meta: { requiresAuth: false, title: "Reset Password" }
        },
        {
          path: ":pathMatch(.*)*",
          component: Error404View,
          meta: { requiresAuth: false, title: "Page does not exist" }
        },
        {
          path: "logout",
          name: "teacher-logout",
          component: LogoutView,
          props: true,
          meta: { requiresAuth: false, title: "Logging out" }
        }
      ],
      meta: {
        level: "teacher"
      }
    },
    // {
    //   // PROTOTYPES
    //   path: "/teacher/p",
    //   name: "teacher-prototype",
    //   component: TeacherPrototypeDefaultView,
    //   props: true,
    //   meta: { requiresAuth: false }
    // },
    {
      name: "parent-routes",
      path: "/:account/",
      component: Parent,

      children: [
        {
          path: "sso",
          name: "parent-sso",
          component: SsoView,
          meta: { requiresAuth: false, title: "SSO for PTC Wizard" }
        },
        {
          path: "login",
          name: "parent-login",
          component: LoginView,
          props: true,
          meta: { requiresAuth: false, title: "Login to PTC Wizard" }
        },
        {
          path: "logout",
          name: "parent-logout",
          component: LogoutView,
          props: true,
          meta: { requiresAuth: false, title: "Logging out" }
        },
        {
          path: "register",
          name: "parent-CreateAccount",
          component: CreateAccount,
          props: true,
          meta: { requiresAuth: false, title: "Create Account" }
        },
        {
          path: "ResetPassword/:uid",
          name: "parent-ResetPassword",
          component: ResetPassword,
          props: true,
          meta: { requiresAuth: false, title: "Reset Password" }
        },
        {
          path: "",
          name: "parent-list",
          component: MyAgenda,
          meta: { requiresAuth: true, title: "Your PTC Wizard schedule " }
        },
        {
          path: "schedule/:id",
          name: "parent-matrix",
          component: MatrixView,
          meta: { requiresAuth: true, title: "Make new appointments" }
        },
        {
          path: "print",
          name: "parent-print",
          component: PrintView,
          props: true,
          meta: { requiresAuth: true, title: "Your PTC Wizard schedule " }
        },
        {
          path: "tutorials/toggle",
          name: "parent-toggle",
          component: ToggleView
        },
        {
          path: ":pathMatch(.*)*",
          component: Error404View,
          meta: { requiresAuth: false, title: "Page does not exist" }
        }
      ],
      meta: {
        level: "parent"
      }
    },
    {
      path: "/:pathMatch(.*)*",
      component: Error404View,
      meta: { requiresAuth: false, title: "Page does not exist" }
    }
  ]
});
const DEFAULT_TITLE = "PTC Wizard || The easiest way to schedule parent teacher conferences";
export const levelsPath = {
  parent: "",
  teacher: "teacher"
};
router.beforeEach((to, from, next) => {
  document.title = (to.meta.title as string) || DEFAULT_TITLE;
  const authStore = useAuthenticationStore();
  const schoolStore = useSchoolStore();
  if (to.params.account) {
    authStore.account = to.params.account as string;
  }
  if (to.meta.level) {
    authStore.level = to.meta.level as any;
  }
  
 
  if (authStore.resetPasswordRequired() && authStore.level === "parent" ) {
    console.log("Password reset is required. Redirecting...");
    const isOnResetPage = to.path.includes('ResetPassword');
    const isOnLogoutPage = to.path.includes('logout');
    const isOnLoginPage = to.path.includes('login');
    if (!isOnResetPage && !isOnLoginPage && !isOnLogoutPage) {
      next({
        path: `/${to.params.account}/ResetPassword/${authStore.jwtData.uid}`,
        replace: true
      });
      return; // Stop further execution after the redirect
    }
  }
  // Handle routes that require authentication
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!authStore.isLoggedIn()) {
      const add = authStore.level === "parent" ? "" : `/${authStore.level}`;
      const logoutPath = authStore.level == "support" ? "support/logout" : `/${to.params.account}${add}/logout`;
      
      next({
        path: logoutPath
      });
    } else {
      // Policy-based check (preferred). Falls back to role-based during backfill.
      const loginRedirect = () => {
        if (authStore.level === "support") {
          next({ path: "/support/login" });
        } else {
          const add = authStore.level === "parent" ? "" : `/${authStore.level}`;
          next({ path: `/${to.params.account}${add}/login` });
        }
      };

      if (to.meta.requiredPolicy) {
        if (!authStore.hasPolicy(to.meta.requiredPolicy)) {
          loginRedirect();
          return;
        }
      } else if (to.meta.requiredPolicies?.length) {
        if (!to.meta.requiredPolicies.some((p) => authStore.hasPolicy(p))) {
          loginRedirect();
          return;
        }
      } else if (to.meta.requiredRoles) {
        // Legacy fallback — remove after all district DBs have policy_role seed data
        const required = to.meta.requiredRoles as string[];
        if (!authStore.canAccess(required)) {
          loginRedirect();
          return;
        }
      }
      next();
    }
  } else {
    next(); // Always call next()!
  }
});
export default router;
